export { default } from "./ClientTileSample";
